module.exports = __webpack_public_path__ + "img/ospreys-logo-icon.3cc916e2.png";